const HEIGHTS = { sm: 28, md: 36, lg: 52 };

export default function Logo({ size = 'md', className = '' }) {
  const h = HEIGHTS[size] || HEIGHTS.md;
  return (
    <img
      src="/haploix.png"
      alt="Haploix"
      aria-label="Haploix"
      style={{ height: h, width: 'auto', display: 'block' }}
      className={className}
    />
  );
}
